import React, { Component } from 'react';
import { connect } from 'react-redux';
import InputRange from 'react-input-range';

import { updateFilters } from '../search/actions';
import { MAGIC_NUMBER } from '../../constants/magicNumbers';

import "react-input-range/lib/css/index.css"
import { getNumberWithCommas } from '../../constants/util';

const mapStateToProps = state => ({
  search: state.Search
});

class DistanceRangeSelect extends Component {
  constructor(props) {
    super(props);

    this.onSelectionChange = this.onSelectionChange.bind(this);
  }

  onSelectionChange = (value) => {
    const { dispatch } = this.props;
    const { filters } = this.props.search;

    const newFilters = [...filters];

    value = Math.max(MAGIC_NUMBER.MIN_DISTANCE, value);
    value = Math.min(MAGIC_NUMBER.MAX_DISTANCE, value);

    newFilters.radius = value;

    dispatch(updateFilters(newFilters));
  }

  render() {
    const { radius } = this.props.search.filters;
    return (
      <div>
        <InputRange
          formatLabel={value => `${getNumberWithCommas(value)} Mile${value === 1 ? '' : 's'}`}
          maxValue={MAGIC_NUMBER.MAX_DISTANCE}
          minValue={MAGIC_NUMBER.MIN_DISTANCE}
          value={radius}
          onChange={this.onSelectionChange}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps)(DistanceRangeSelect);
